import { Component } from 'react'

export default class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack)
  }

  handleReload = () => {
    this.setState({ error: null })
    window.location.assign('/')
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="min-h-svh flex items-center justify-center p-6 bg-white">
        <div className="max-w-md text-center">
          <h1 className="font-display text-3xl font-semibold text-ink-900 mb-3">
            Something broke on our end.
          </h1>
          <p className="text-ink-500 mb-6">
            Try reloading the page — your work is safe.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="inline-flex items-center justify-center min-h-11 px-5 rounded-lg bg-brand-600 text-white font-semibold hover:bg-brand-700"
          >
            Reload SolaGrant
          </button>
        </div>
      </div>
    )
  }
}
